import { IconSvg, colors } from '@ajaibid/components';
import React, { useState } from 'react';

import BANNER_PREMIUM from 'Image/Profile/Banner/Premium.png';
import BANNER_BONUS from 'Image/Profile/Banner/Bonus.png';

import { useNavigate } from 'react-router-dom';
import { bool } from 'prop-types';
import { styBannerContainer } from './style';

const slideStyles = {
  width: '100%',
  height: '100%',
  borderRadius: '10px',
  backgroundSize: 'cover',
};

const rightArrowStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  right: '17px',
  fontSize: '45px',
  color: colors.NEUTRAL_0,
  zIndex: 1,
  cursor: 'pointer',
};

const leftArrowStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)',
  left: '17px',
  fontSize: '45px',
  color: colors.NEUTRAL_0,
  zIndex: 1,
  cursor: 'pointer',
};

const sliderStyles = {
  position: 'relative',
  height: '100%',
};

const dotsContainerStyles = {
  display: 'flex',
  justifyContent: 'center',
  paddingTop: 0,
};

const dotStyle = {
  margin: '0 4px',
  cursor: 'pointer',
};

const SlideBanner = ({
  emailVerified,
  isPremium,
  isPremiumTrial,
  userNotKycYet,
  stockKycVerifying,
  mfKycVerifying,
  stockKycVerified,
  stockKycError,
}) => {
  const navigate = useNavigate();

  const slidesSource = [
    {
      url: BANNER_PREMIUM,
      title: 'premium',
      func: () => window.open('https://ajaib.co.id/ajaib-prime/'),
    },
    { url: BANNER_BONUS, title: 'referral', func: () => navigate('/referral') },
  ];

  const slides = isPremium || isPremiumTrial ? slidesSource.slice(1) : slidesSource;

  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };
  const goToNext = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };
  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };
  const slideStylesWidthBackground = {
    ...slideStyles,
    cursor: 'pointer',
    backgroundImage: `url(${slides[currentIndex]?.url})`,
  };

  return (
    <div
      className={styBannerContainer({
        emailVerified,
        userNotKycYet,
        stockKycVerifying,
        mfKycVerifying,
        stockKycVerified,
        stockKycError,
      })}
    >
      <div style={sliderStyles}>
        <div>
          {currentIndex !== 0 && (
            <div onClick={goToPrevious} style={leftArrowStyles}>
              <IconSvg.Chevron.Left color={colors.NEUTRAL_0} />
            </div>
          )}

          {currentIndex + 1 !== slides.length && (
            <div onClick={goToNext} style={rightArrowStyles}>
              <IconSvg.Chevron.Right color={colors.NEUTRAL_0} />
            </div>
          )}
        </div>
        <div style={slideStylesWidthBackground} onClick={slides[currentIndex].func} />
        <div style={dotsContainerStyles}>
          {slides?.map((slide, slideIndex) => (
            <div style={dotStyle} key={slideIndex} onClick={() => goToSlide(slideIndex)}>
              <svg
                width="16"
                height="2"
                viewBox="0 0 16 2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="16"
                  height="2"
                  rx="1"
                  fill={slideIndex === currentIndex ? colors.AJAIB_BLUE_5 : colors.AJAIB_BLUE_1}
                />
              </svg>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

SlideBanner.propTypes = {
  emailVerified: bool,
  isPremiumTrial: bool,
  isPremium: bool,
  userNotKycYet: bool,
  stockKycVerifying: bool,
  mfKycVerifying: bool,
  stockKycVerified: bool,
  stockKycError: bool,
};

SlideBanner.defaultProps = {
  emailVerified: false,
  isPremiumTrial: false,
  isPremium: false,
  userNotKycYet: false,
  stockKycVerifying: false,
  mfKycVerifying: false,
  stockKycVerified: false,
  stockKycError: false,
};

export default SlideBanner;
